import React from 'react';
import { Flame, FlaskRound as Flask, Factory, Zap, Building2, Cog } from 'lucide-react';

const industries = [
  { icon: Flame, name: 'Oil & Gas' },
  { icon: Flask, name: 'Pharmaceuticals' },
  { icon: Factory, name: 'Chemical Processing' },
  { icon: Zap, name: 'Power Generation' },
  { icon: Building2, name: 'Engineering Firms' },
  { icon: Cog, name: 'Manufacturing' },
];

export default function Industries() {
  return (
    <section className="py-20 bg-white" id="industries">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center text-black mb-4">
          Industries That Trust Our Platform
        </h2>
        <p className="text-xl text-center text-black mb-16 max-w-2xl mx-auto">
          Trusted by leading companies across multiple high-risk industries
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {industries.map((industry, index) => {
            const Icon = industry.icon;
            return (
              <div 
                key={index}
                className="flex flex-col items-center p-6 text-center hover:transform hover:scale-105 transition-transform"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-900 rounded-full flex items-center justify-center mb-4">
                  <Icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-black">
                  {industry.name}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}